import { useNavigation } from '@react-navigation/native'
import React from 'react'

import { Avatar } from 'widgets/Avatar'
import { Box } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { useMultipleUsers } from 'hooks/useMultipleUsers'
import { useSubscriptions } from 'hooks/useSubscriptions'

import { links } from 'utils/constants'

import { Subscription } from 'types/subscription'

type UpspaceRowMembersProps = {
  subscription: Subscription
  itemSize: number
}

export const UpspaceRowMembers = ({ subscription, itemSize }: UpspaceRowMembersProps) => {
  const navigation = useNavigation<any>()

  const { data: subscriptions } = useSubscriptions({
    trainerId: subscription.program.trainer.id,
  })

  const { data: members } = useMultipleUsers({
    userIds: subscriptions?.map((sub) => sub.user.id as string) ?? [],
  })

  if (!members?.length) return null

  const handleMembersPress = () => {
    navigation.navigate(links.FOLLOWERS_MEMBERS_PAGE, {
      trainerId: subscription.program.trainer.id,
    })
  }

  return (
    <Box flexDirection='row'>
      {members && members.length > 0 && (
        <>
          <Box margin={{ horizontal: 'xs' }}>
            <Avatar width={itemSize} height={itemSize} image={members[0]?.avatar} />
          </Box>
          {members.length > 1 && (
            <>
              <Box margin={{ horizontal: 'xs' }}>
                <Avatar width={itemSize} height={itemSize} image={members[1]?.avatar} />
              </Box>
              <Pressable onPress={handleMembersPress}>
                <Box
                  margin={{ left: 'xs', right: 'smd' }}
                  width={itemSize}
                  height={itemSize}
                  justifyContent='center'
                  align='center'
                  backgroundColor='greyLight'
                  borderRadius='xl'
                >
                  <Text fontSize='xs' fontWeight='semiBold'>
                    +{members.length}
                  </Text>
                </Box>
              </Pressable>
            </>
          )}
        </>
      )}
    </Box>
  )
}
